import { useState } from 'react';

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);

  const phones = [
    { number: '19175049095', name: 'Luisa', label: 'WhatsApp - Luisa' },
    { number: '19177084424', name: 'Henry', label: 'WhatsApp - Henry' },
  ];

  return (
    <div
      className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-[100] flex flex-col items-end"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Tooltip / expanded options */}
      {hovered && (
        <div className="mb-3 flex flex-col gap-2 animate-in fade-in slide-in-from-bottom-2 duration-200">
          {phones.map((p) => (
            <a
              key={p.number}
              href={`https://wa.me/${p.number}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-white text-brand-dark text-sm font-medium px-4 py-2.5 rounded-xl shadow-lg hover:bg-brand-gold transition-colors whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-green-500 text-lg" />
              <span>{p.label}</span>
            </a>
          ))}
          <a
            href="tel:+13473606636"
            className="flex items-center gap-2 bg-white text-brand-dark text-sm font-medium px-4 py-2.5 rounded-xl shadow-lg hover:bg-brand-gold transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line text-brand-red text-lg" />
            <span>Llamar - (347) 360-6636</span>
          </a>
        </div>
      )}

      {/* Main button */}
      <a
        href="https://wa.me/19175049095"
        target="_blank"
        rel="noopener noreferrer"
        className="w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-110 transition-all duration-300 animate-pulse hover:animate-none"
        aria-label="WhatsApp"
      >
        <i className="ri-whatsapp-line text-2xl" />
      </a>
    </div>
  );
}